import { AuthLayout } from '../components/AuthLayout/AuthLayout';
import { LoginForm } from '../components/login/LoginForm';

export const LoginPage = () => {
  return (
    <AuthLayout>
      <LoginForm />
    </AuthLayout>
  );
};
